// @flow

import React, { type Node } from 'react';
import { type Country } from '@tectonics/prs/country';
import { getCountry, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Text } from '../../../commons/atoms';

export function CashTitle(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  return (
    <Text flavor="display" style={{ fontSize: '22px', color: '#2397d4', marginBottom: '16px' }}>
      <CashTitleMessage country={country} />
    </Text>
  );
}

type CashTitleMessageProps = {|
  country: Country,
|};

function CashTitleMessage({ country }: CashTitleMessageProps): Node {
  switch (country) {
    case 'bo':
      return 'Número de recaudación generado!';
    default:
      return 'Tu voucher de pago fue generado.';
  }
}
